import { FC } from 'react'
import { PathRouteProps } from 'react-router-dom'
import type { SvgIconProps } from '@mui/material/SvgIcon'

enum Pages {
  NotFound = 'NotFound',
  Login = 'Login',
  PanDetail = 'PanDetail',
  Home = 'Home',
  CreateLead = 'CreateLead',
  CreateOpportunity = 'CreateOpportunity',
  BusinessDetails = 'BusinessDetails',
  CapturePhoto = 'CapturePhoto',
  KycDetails = 'KycDetails',
  Products = 'Products',
  LeadsListing = 'LeadsListing',
  BankAccount = 'BankAccount',
  VasListing = 'VasListing',
  ReviewDetails = 'ReviewDetails',
  PricingPlan = 'PricingPlan',
  ProductReview = 'ProductReview',
  POPayment = 'POPayment',
  NachMandate = 'NachMandate',
  NachMandateStatus = 'NachMandateStatus',
  PurchaseOrder = 'PurchaseOrder',
  NachLotusStatus = 'NachLotusStatus',
  Deployment = 'Deployment',
  PricingLWC = 'PricingLWC',
  DeploymentMulti = 'DeploymentMulti',
  OtherBusinessDoc = 'OtherBusinessDoc',
  PartnershipKyc = 'PartnershipKyc',
  FAQScreen = 'FAQScreen',
  YoutubePlayer = 'YoutubePlayer',
  AllFAQSection = 'AllFAQSection',
  MultiStores = 'MultiStores',
  LiveDevices = 'LiveDevices',
  LiveDeviceDetails = 'LiveDeviceDetails',
  CompleteDeploment = 'CompleteDeploment',
  LinkPaymentDevices = 'LinkPaymentDevices',
  MapDevices = 'MapDevices',
  TestTransactions = 'TestTransactions',
  ClosureRemarks = 'ClosureRemarks',
  NachDocumentUpload = 'NachDocumentUpload',
  InventoryManagement = 'InventoryManagement',
  MyAttendance = 'MyAttendance',
  Notifications = 'Notifications',
  LeadNotification = 'LeadNotification',

  RevisitFeedback = 'revisit/feedback',
  RevisitMerchantDetails = 'revisit/merchant-details',
  RevisitComplete = 'revisit/complete',
  RevisitConfirmLocation = 'revisit/confirm-location',
  RevisitConfirmOTP = 'revisit/confirm-otp',
  RevisitShopForm = 'revisit/shopform',
  RevisitPhotos = 'revisit/photos',
  RevisitMapQR = 'revisit/map-qr',
  RevisitLoading = 'revisit/loading',
  MdrProduct = 'MdrProduct',
  ProductDetail = 'ProductDetail',
  PreviewOrder = 'PreviewOrder',
  CaptureShopPhoto = 'CaptureStoreStock',
  BODetails = 'BeneficialOwner',
  VasServices = 'VasServices',
  SelectVas = 'SelectVas',
  Vases = 'Vases',
  ViewExistingVas = 'ViewExistingVas',
  MapVas = 'MapVas',
  MapVasDevices = 'MapVasDevices',
  CSEL1Review = 'CseL1InReview',
  VasActivationRequested = 'VasActivationRequested',
  // NoPosProductDetail = 'NoPosProductDetail',
  NotificationProductDetail = 'NotificationProductDetail',
  AccessoryProductDetail = 'AccessoryProductDetail',
}

type PathRouteCustomProps = {
  title?: string
  component: FC
  icon?: FC<SvgIconProps>
}

type Routes = Record<Pages, PathRouteProps & PathRouteCustomProps>

export type { Routes }

export { Pages }
